import React, { Suspense, useCallback, useState } from "react";
import styles from "./SignHeader.module.css";
import SignDesktopNav from "./SignHeaderComponents/SignDesktopNav";
import SignMobileNav from "./SignHeaderComponents/SignMobileNav";
import logo from "../../../logo.webp";
import HeaderLoginOptions from "../../LandingComponents/HeaderLoginOptions/HeaderLoginOptions";
import HeaderRegisterOptions from "../../LandingComponents/HeaderRegisterOptions/HeaderRegisterOptions";

const SignHeader = ({}) => {
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [activeHash, setActiveHash] = useState(window.location.hash || "#home");
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const openRegister = useCallback(() => setIsRegisterOpen(true), []);
  const closeRegister = useCallback(() => setIsRegisterOpen(false), []);

  const openLogin = useCallback(() => {
    setIsHovered(false);
    setIsLoginOpen(true);
  }, []);

  const closeLogin = useCallback(() => setIsLoginOpen(false), []);

  return (
    <>
      <header className={styles.header}>
        <div className={styles.menuBtn} onClick={toggleNavbar}>
          {isNavbarVisible ? "✕" : "☰"}
        </div>

        <a href="/" className={styles.headerLogo}>
          <img width={200} src={logo} alt="Logo" />
        </a>

        <SignMobileNav
          isNavbarVisible={isNavbarVisible}
          toggleNavbar={toggleNavbar}
          activeHash={activeHash}
          openLogin={openLogin}
          openRegister={openRegister}
          isHovered={isHovered}
          setIsHovered={setIsHovered}
        />
        <SignDesktopNav
          toggleNavbar={toggleNavbar}
          activeHash={activeHash}
          openLogin={openLogin}
          openRegister={openRegister}
          isHovered={isHovered}
          setIsHovered={setIsHovered}
        />
      </header>
      <Suspense fallback={<div>Loading...</div>}>
        {isLoginOpen && (
          <HeaderLoginOptions
            isLoginOpen={isLoginOpen}
            closeLogin={closeLogin}
          />
        )}
        {isRegisterOpen && (
          <HeaderRegisterOptions
            isRegisterOpen={isRegisterOpen}
            closeRegister={closeRegister}
          />
        )}
      </Suspense>
    </>
  );
};

export default SignHeader;
